module.exports = __webpack_public_path__ + "static/media/american-express.a8549bb7.svg";